export const labelStyles = {
    backgroundColor: '#fff',
    padding: '0 4px',
    position: 'absolute',
    top: '-4px',
    left: '8px',
    zIndex: 1,
    display: 'block',
    fontSize: '13px',
    color: '#94A3B8',
    width: 'fit-content',
    fontWeight: 500,
    whiteSpace: 'nowrap',
};

export const inputStyles = {
    borderRadius: '8px',
    borderColor: '#E2E8F0',
    height: 48,
    fontWeight: 400,
    '& input::placeholder': {
        color: '#94A3B8',
        opacity: 1,
    },
};
